import { Upload, X, Image, FileText } from "lucide-react";

const MAX_FILE_COUNT = 5;

export const FileUploadStep = ({ uploadedFiles, fileInputRef, onFileUpload, onRemoveFile }) => (
  <div data-testid="quote-step-4" className="space-y-6">
    <div>
      <h2 className="font-heading text-2xl font-bold uppercase text-brand-navy mb-2">
        Upload Plans/Photos
      </h2>
      <p className="text-brand-slate">
        Optional: Share any existing plans, photos, or documents
      </p>
    </div>

    {/* Upload Area */}
    <div
      onClick={() => fileInputRef.current?.click()}
      className="border-2 border-dashed border-brand-slate/30 rounded-sm p-8 text-center cursor-pointer hover:border-brand-orange/50 hover:bg-brand-orange/5 transition-colors"
    >
      <Upload className="w-12 h-12 text-brand-slate/50 mx-auto mb-4" />
      <h3 className="font-heading text-lg font-bold text-brand-navy mb-2">
        Drag & Drop or Click to Upload
      </h3>
      <p className="text-sm text-brand-slate">
        Accepted: Images, PDF, DOC (Max 10MB each, up to {MAX_FILE_COUNT} files)
      </p>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*,.pdf,.doc,.docx"
        onChange={onFileUpload}
        className="hidden"
        data-testid="file-upload"
      />
    </div>

    {/* Uploaded Files List */}
    {uploadedFiles.length > 0 && (
      <div className="space-y-3">
        <h4 className="font-heading font-bold text-brand-navy uppercase text-sm">
          Uploaded Files ({uploadedFiles.length}/{MAX_FILE_COUNT})
        </h4>
        {uploadedFiles.map((file, index) => (
          <div
            key={`${file.name}-${file.size}`}
            className="flex items-center gap-3 bg-brand-ice p-3 rounded-sm"
          >
            {file.type.startsWith("image/") ? (
              <Image className="w-8 h-8 text-brand-orange" />
            ) : (
              <FileText className="w-8 h-8 text-brand-orange" />
            )}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-brand-navy truncate">
                {file.name}
              </p>
              <p className="text-xs text-brand-slate">
                {(file.size / 1024 / 1024).toFixed(2)} MB
              </p>
            </div>
            <button
              type="button"
              onClick={() => onRemoveFile(index)}
              className="p-1 hover:bg-red-100 rounded-full"
            >
              <X className="w-5 h-5 text-red-500" />
            </button>
          </div>
        ))}
      </div>
    )}

    <p className="text-sm text-brand-slate text-center">
      This step is optional. You can submit your quote request without uploading files.
    </p>
  </div>
);
